import { render, staticRenderFns } from "./counting.vue?vue&type=template&id=afcb944a&scoped=true&"
import script from "./counting.vue?vue&type=script&lang=js&"
export * from "./counting.vue?vue&type=script&lang=js&"
import style0 from "./counting.vue?vue&type=style&index=0&id=afcb944a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcb944a",
  null
  
)

export default component.exports